import { z } from "zod";

const PlanningStatusSchema = z.enum(["Approved", "Unknown", "Withdrawn", "Rejected", "Pending"]);
export type PlanningStatus = z.infer<typeof PlanningStatusSchema>;

export const PlanningFiltersSchema = z.object({
  showResidential: z.boolean(),
  showCommercial: z.boolean(),
  showOther: z.boolean(),
  showBoundaries: z.boolean(),
  maxYear: z.number(),
  minSize: z.number(),
  enabledTypes: z.array(z.string()),
  enabledStatuses: z.array(PlanningStatusSchema),
  description: z.string(),
  showAppealed: z.boolean(),
});

export type PlanningFilters = z.infer<typeof PlanningFiltersSchema>;
